
import React from 'react';
import { Select, MenuItem } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';

export default function ChannelDropDownMenu(props) {
  const { control } = useForm();

  const handleChannelChange = (e) => {
    const selectedChannel = e.target.value;
    props.handleChannelFilter('channel', selectedChannel);
  };

  const shababunaId =
    props.channelData?.find((c) => c.name === "SHABABUNA")?._id ||
    process.env.REACT_APP_SHABABUNA_CHANNEL_ID ||
    "657979c059be05f5f8dd41f6";

  React.useEffect(() => {
    if (shababunaId && props.channelData?.length) {
      props.handleChannelFilter("channel", shababunaId);
    }
  }, [props.channelData]);

  return (
    <div>
      <p style={{ marginBottom: "2px", fontSize: "14px", color: "#808080" }}>
        Filter by Channel
      </p>

      <form>
        <Controller
          name="channel"
          control={control}
          defaultValue={shababunaId}
          render={({ field }) => (
            <Select
              {...field}
              value={field.value || shababunaId}
              onChange={(e) => {
                field.onChange(e);
                handleChannelChange(e);
              }}
              sx={{
                width: "200px",
                borderRadius: "0px",
                border: "1px solid #000",
                height: "40px",
              }}
            >
              {props.channelData.map((item) => (
                <MenuItem key={item._id} value={item._id}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          )}
        />
      </form>
    </div>
  );
}
